import {
  gql,
  OperationVariables,
  QueryHookOptions,
  useQuery,
} from '@apollo/client';
import { GetIdpDomainsQuery } from '@investigator/shared/generated/graphql';

export const GET_IDP_DOMAINS = gql`
  query getIdpDomains {
    getIdpDomains {
      domains
      pagination {
        offset
        size
        total_items
      }
    }
  }
`;

export const useGetIdpDomains = (
  options: QueryHookOptions<GetIdpDomainsQuery, OperationVariables>,
) => {
  return useQuery<GetIdpDomainsQuery>(GET_IDP_DOMAINS, options);
};
